import axios from "axios";
import {getLocalAccessToken, getLocalRefreshToken, updateLocalAccessToken,} from "./token.service";
import {apiLogout} from "./auth.service";
import { showCustomToast } from "../utils/toast";

const instance = axios.create({
  baseURL: process.env.REACT_APP_GW3_API_URL,
  headers: {
    "Content-Type": "application/json",
  }
});

instance.interceptors.request.use(
  async(config) => {
    const token = getLocalAccessToken();
    if (token && !config.headers["Authorization"]) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;
    if (
      originalConfig.url === "/auth/jwt/refresh/" &&
      (err.response.status === 401 || err.response.status === 404)
    ) {
      apiLogout();
    } else if (
      (originalConfig.url === "/auth/jwt/create/" ||
        originalConfig.url === "/auth/cognito/exchange/") &&
      err.response.status === 401
    ) {
      showCustomToast(apiLogout)
    } else if (
      originalConfig.url !== "/auth/jwt/create/" &&
      originalConfig.url !== "/auth/cognito/exchange/" &&
      err.response
    ) {
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        const refresh = getLocalRefreshToken();
        if (refresh) {
          try {
            const rs = await instance.post("/auth/jwt/refresh/", {
              refresh
            });
            const access = rs.data.access;
            updateLocalAccessToken(access);

            return instance(originalConfig);
          } catch (_error) {
            return Promise.reject(_error);
          }
        } else apiLogout();
      }
    }

    return Promise.resolve(err.response);
  }
);

export default instance;
